export const SETTINGS = {
  fps: 60,
  // Three.js
  camera: {
    fov: 75,
    aspect: 1,
    near: 0.1,
    far: 100,
  },
}